import { useContext, useReducer, createContext, useCallback } from "react";
import { useRequest } from "../../services/request";
import { createThumb } from "../../utilities/functions";

const Context = createContext();

export function useSigners() {
  return useContext(Context);
}

const initState = {
  list: [],
  selected: null,
  count: 0,
  page: 0,
  perPage: 10,
  status: "idle",
  error: null,
  companyID: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "set_list":
      return { ...state, list: [...action.payload] };
    case "set_selected":
      if (action.keep && state.selected) return { ...state };
      return { ...state, selected: { ...action.payload } };
    case "set_count":
      return { ...state, count: action.payload };
    case "add":
      const newList = [{ ...action.payload }, ...state.list];
      return { ...state, list: newList };
    case "edit":
      const modified = state.list.map((p) =>
        p.id === action.payload.id ? { ...p, ...action.payload } : p
      );
      return { ...state, list: modified };
    case "delete":
      const filtered = state.list.filter((p) => p.id !== action.payload);
      return { ...state, list: filtered };
    case "status":
      return { ...state, status: action.payload };
    case "set_page":
      return { ...state, page: action.payload };
    case "set_per_page":
      return { ...state, perPage: action.payload };

    case "companyChange":
      return { ...state, companyID: action.payload };

    default:
      throw new Error(`Invalid dispatch type: ${action.type}`);
  }
};

export default function SignersProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initState);
  const req = useRequest();

  const fetchList = useCallback(
    async (id, page, pageSize = 10, keyword = null) => {
      dispatch({ type: "status", payload: "fetching" });
      let headersData = {
        pageNumber: state.page + 1,
        pageSize,
      };
      console.log(id, "id resData");

      const resData = await req(
        `DocSigner/List/${id}`,
        null,
        {},
        true,
        headersData
      );
      console.log(resData, "resData");
      dispatch({ type: "status", payload: `idle` });
      dispatch({ type: "set_list", payload: resData.data });
      dispatch({ type: "set_count", payload: resData.data.totalSize });
    },
    [req, state.page]
  );

  const fetchOne = useCallback(
    (id) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `fetching` });
        const resData = await req(`DocSigner/Info/${id}/`, null, {}, true);
        console.log("result", resData);
        dispatch({ type: "set_selected", payload: resData.data });
        dispatch({ type: "status", payload: `idle` });
        resolve(resData.data);
      });
    },
    [req]
  );

  const create = useCallback(
    async (data) => {
      let resData;
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `creating` });
        try {
          resData = await req(
            "DocSigner/Create",
            data,
            { method: "POST" },
            true
          );

          resolve(resData.data);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req]
  );

  const edit = useCallback(
    async (id, data) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `creating` });
        try {
          const resData = await req(
            `DocSigner/Update/${id}`,
            data,
            { method: "PUT" },
            true
          );
          console.log(resData.data, "provider");
          dispatch({ type: "edit", payload: resData.data });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req]
  );

  const remove = useCallback(
    async (id) => {
      dispatch({ type: "status", payload: `deleting ${id}` });
      await req(`DocSigner/Delete/${id}`, {}, { method: "DELETE" }, true);
      dispatch({ type: "status", payload: "idle" });
      dispatch({ type: "delete", payload: id });
    },
    [req]
  );

  return (
    <Context.Provider
      value={{
        state,
        dispatch,
        fetchList,
        fetchOne,
        create,
        edit,
        remove,
      }}
    >
      {children}
    </Context.Provider>
  );
}
